import { css } from '@emotion/css'
import { FlexBox } from '@fable/components'
import { useStats } from '../../lib/ctx/stats'
import { StatsHeroReadingGoal } from './StatsHeroReadingGoal'
import { StatsHeroFallback } from './StatsHeroFallback'
import { useStatsPermission } from '../../lib/hooks'

export const StatsHero = () => {
  const { isStatsOwner } = useStatsPermission()
  const [hasReadingGoal, isProfileView, goalOptIn] = useStats((s) => [
    !!s.stats?.reading_goal,
    s.isProfileView,
    s.goalOptIn,
  ])

  if (isProfileView && !goalOptIn) return null

  const isFallback = (!isStatsOwner && !goalOptIn) || !hasReadingGoal

  return (
    <FlexBox
      data-testid={`stats-hero${isFallback ? '-fallback' : ''}`}
      className={css`
        margin-bottom: 20px;
        padding-top: 21px;
        width: 100%;
        position: relative;
        transition: background-color ease-in-out 0.6s, color 0.6s;
      `}
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
    >
      {isFallback ? <StatsHeroFallback /> : <StatsHeroReadingGoal />}
    </FlexBox>
  )
}
